import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus, { ElNotification } from 'element-plus';
import './assets/styles/tailwind.css';
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import axios from 'axios';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { authService } from './services/authService';
import { ROLES, ROUTES } from './config/constants';
import ja from 'element-plus/es/locale/lang/ja';

// 请求拦截器
axios.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      // 将token添加到请求头中
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response: any) => {
    if (response.status === 200) {
      const token = response.headers.authorization?.split(' ')[1];
      if (token) {
        const decodedHeader = jwtDecode<JwtPayload>(token, { header: false }) as any;
        if (decodedHeader) {
          decodedHeader['token'] = token;
          decodedHeader['user_role'] = decodedHeader['user_level'];
          
          authService.setUserInfo(decodedHeader);
        } else {
          localStorage.setItem('token', token);
        }
      }
    }

    return response;
  },
  (error: { response: { status: any; }; }) => {
    const status = error.response.status;
    if (status === 401) {
      authService.removeUserInfo();
 
      router.push(`/${ROUTES.LOGIN}`);
    } else if (status === 404) {
      router.push(`/${ROUTES.NOT_FOUND}`);
    } else if (status === 403) {
      router.push(`/${ROUTES.FORBIDDEN}`);
    }

    return Promise.reject(error);
  }
);


const app = createApp(App);

app.use(router);
app.use(ElementPlus, { locale: ja });
// app.config.globalProperties.$messaging = messaging
app.mount('#app');